import { serializable } from 'serializr';
import { observable, computed } from 'mobx';
import AgentBase from './../shared/agent-base';

export default class AgentModel extends AgentBase {
    constructor() {
        super();
    }

    @observable coordinatorId;
    @serializable @observable tcFileId = '';
    @serializable @observable agentProfile = { preferences: '', preferredEmail: '', notes: '' };
    @serializable @observable brokerageProfile = { preferences: '' };

    @computed
    get profile() {
        return this.agentProfile;
    }

    @computed
    get correspondenceEmail() {
        return this.agentProfile.preferredEmail !== '' && this.agentProfile.preferredEmail
            ? this.agentProfile.preferredEmail
            : this.email;
    }

    @computed
    get emailContact() {
        return {
            email: this.correspondenceEmail,
            firstName: this.firstName,
            lastName: this.lastName,
            name: this.name,
        };
    }
}



// WEBPACK FOOTER //
// ./src/agents/agent-model.js